RivalIQ.module('enums.chart', function (enums) {
    'use strict';

    // NOTE this should match @fixed-chart-height
    enums.CHART_HEIGHT = 425;
});
